import {applyMiddleware, combineReducers} from 'redux';
import {createStore} from 'redux';
import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  getRegisteredReduxMiddleware,
  getRegisteredExportedReducers,
  getRegisteredPersistentReducerKeys,
} from './registerWithStore';

export function configureStore() {
  // Configure persistence
  const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: getRegisteredPersistentReducerKeys(),
  };

  // Set up reducers
  const rootReducer = combineReducers(getRegisteredExportedReducers());

  // Create persisted reducer
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  // Add middleware
  const middleware = applyMiddleware(...getRegisteredReduxMiddleware());

  // ...finally create the store.
  const store = createStore(persistedReducer, middleware);

  //@ts-ignore
  const persistor = persistStore(store);

  return {store, persistor};
}
